<template>
    <div>
        <Head title="Тарифи"/>
        <h1 class="mb-8 text-3xl font-bold">Атрибути риболовлі</h1>
        <div class="flex items-center justify-between mb-6">
            <Link
                class="btn-indigo"
                :href="$route('attributes.create')"
            >
                <span>Створити</span>
                <span class="hidden md:inline"> атрибут</span>
            </Link>
        </div>
        <div class="bg-white rounded-md shadow overflow-x-auto">
            <table class="w-full whitespace-nowrap">
                <tr class="text-left font-bold">
                    <th class="pb-4 pt-6 px-6">Назва</th>
                    <th class="pb-4 pt-6 px-6">Ціна</th>
                </tr>
                <tr v-for="attribute in attributes.data" :key="attribute.id"
                    class="hover:bg-gray-100 focus-within:bg-gray-100">
                    <td class="border-t">
                        <Link
                            class="flex items-center px-6 py-4 focus:text-indigo-500"
                            :href="$route('attributes.edit', attribute.id)"
                            tabindex="-1"
                        >
                            {{ attribute.title }}
                        </Link>
                    </td>
                    <td class="border-t">
                        <Link
                            class="flex items-center px-6 py-4 focus:text-indigo-500"
                            :href="$route('attributes.edit', attribute.id)"
                            tabindex="-1"
                        >
                            {{ attribute.price }}
                        </Link>
                    </td>
                </tr>
                <tr v-if="attributes.data.length === 0">
                    <td class="px-6 py-4 border-t" colspan="4">Немає жодного запису</td>
                </tr>
            </table>
        </div>
        <pagination class="mt-6" :links="attributes.links"/>
    </div>
</template>

<script>
import {Head, Link} from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon.vue'
import Layout from '@/Shared/Layout.vue'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination.vue'
import SearchFilter from '@/Shared/SearchFilter.vue'

export default {
    components: {
        Head,
        Icon,
        Link,
        Pagination,
        SearchFilter,
    },
    layout: Layout,
    props: {
        attributes: Object,
    },
    data() {
        return {
        }
    },
    methods: {
        reset() {
            this.form = mapValues(this.form, () => null)
        },
    }
}
</script>
